import { ContentSuggestionParams } from 'components/Filters/context/SearchBarContext/types';
import { SearchFilterType } from 'types/generated/samplesApi';
import { FiltersParams } from 'types/params';

const getFilterParamsToType = (
    params: FiltersParams | ContentSuggestionParams,
) => {
    let type = undefined as SearchFilterType | undefined;

    switch (params) {
        case FiltersParams.instruments:
            type = 'Instruments';
            break;
        case FiltersParams.genres:
            type = 'Genres';
            break;
        case FiltersParams.textsearch:
            type = 'Textsearch';
            break;
        case FiltersParams.sfxs:
            type = 'Sfxs';
            break;
        case FiltersParams.tags:
            type = 'Tags';
            break;
        case ContentSuggestionParams.suggestedlabels:
            type = 'SuggestedLabel';
            break;
        case ContentSuggestionParams.suggestedpacks:
            type = 'SuggestedPack';
            break;
    }

    return type;
};

export default getFilterParamsToType;
